import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { useLocalization } from "../../../../utilities/hooks/use-localization";
import { UnicodeCharacterConstants } from "constants/unicode-character-constants";

// Move to panel dir
const useAccountInformationTab = () => {
    const { globalState } = useGlobalState();
    const { t } = useLocalization();
    const accountInfoLabel = t("accountInformationTab-header");
    const emailLabel = t("email");
    const emailNotAvailable = t("field-notAvailable", { item: emailLabel });

    const nameLabel = t("field-fullName");
    const nameNotAvailable = t("field-notAvailable", { item: nameLabel });

    const email = globalState.currentIdentity?.user?.email;

    const fullName = globalState.currentIdentity?.user?.getFirstAndLastName();

    const password = UnicodeCharacterConstants.Bullet.repeat(12);

    const organizationId =
        globalState.currentIdentity?.getCurrentUserRoleOrganization()
            ?.organizationId ?? -1;

    return {
        accountInfoLabel,
        email,
        emailLabel,
        emailNotAvailable,
        fullName,
        nameLabel,
        nameNotAvailable,
        password,
        organizationId,
    };
};

export default useAccountInformationTab;
